export enum TelecomProvider {
  Vodafone = 1,
  Other = 2,
  Twilio = 3,
  Turkcell = 4,
  TurkTelekom = 5,
}
